import React from 'react';
import ItemRowMenu from '~/app/common/ItemRowMenu';
import useTranslation from '~/app/hooks/useTranslation';
import { Part } from '~/types';

export interface PartRowMenuProps {
  part: Part
  onEdit?: (part: Part) => void
  onRemove: (part: Part) => void
}

export type PartRowMenuComponent = React.FC<PartRowMenuProps>

const PartRowMenu: PartRowMenuComponent = ({ part, onEdit, onRemove }) => {
  const { t } = useTranslation('parts');

  return (
    <ItemRowMenu
      item={part}
      onEdit={onEdit}
      onRemove={onRemove}
      confirmationText={t('removeConfirm')}
    />
  );
};

export default PartRowMenu;
